/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";

import { DateTimePicker } from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Snackbar,
  Alert,
  Autocomplete,
  Chip,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import { Formik } from "formik";
import Loading from "../components/Loading";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({ apUsers, jobs, task, taskId }) {
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const snackRef = useRef(null);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const submit = async (values, resetForm) => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/tasks/${taskId}`,
        {
          title: values.title,
          description: values.description,
          assigned_to: values.assigned_to._id,
          associated_job: values.associated_job?._id || "",
          deadline: values.deadline,
        },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        snackRef.current.click();
        resetForm({ values: "" });
        navigate("/dashboard/tasks/", {
          state: { success: true, message: "Task Updated Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      console.log(e, "error");
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
      snackRef.current.click();
    }
  };

  useEffect(() => {
    console.log(err);
  }, [err]);
  return (
    <>
      <Formik
        initialValues={{
          title: task.title,
          description: task.description,
          assigned_to: task.assigned_to,
          associated_job: task.associated_job,
          deadline: task.deadline,
          submit: false,
        }}
        validationSchema={Yup.object().shape({
          title: Yup.string().required("Title is required"),
          assigned_to: Yup.object().required("Assigned to is required"),
          associated_job: Yup.object(),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm }
        ) => {
          try {
            submit(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          setFieldValue,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          touched,
          values,
        }) => (
          // <></>
          <form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Task updated Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <Card mb={6}>
                <CardContent>
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h6" gutterBottom>
                          Update Task
                          <Chip
                            label={task.status.toUpperCase()}
                            color="primary"
                            size="small"
                            sx={{ ml: 2, mb: 1 }}
                          />
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Grid container spacing={5}>
                          <Grid item xs={12} md={12} lg={12}>
                            <TextField
                              fullWidth
                              name="title"
                              value={values.title}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={Boolean(touched.title && errors.title)}
                              id="search-field"
                              label="Title * "
                              helperText={touched.title && errors.title}
                            />
                          </Grid>
                          <Grid item xs={12} lg={12} md={12}>
                            <FormControl
                              error={Boolean(
                                touched.required_date && errors.required_date
                              )}
                              fullWidth
                            >
                              <DateTimePicker
                                name="deadline"
                                renderInput={(props) => (
                                  <TextField {...props} />
                                )}
                                label="Deadline"
                                value={values.deadline || null}
                                onChange={(newValue) => {
                                  setFieldValue("deadline", newValue);
                                }}
                                onBlur={handleBlur}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                touched.assigned_to && errors.assigned_to
                              )}
                            >
                              <Autocomplete
                                id="combo-box-demo"
                                options={apUsers}
                                defaultValue={values.assigned_to}
                                value={values?.assigned_to}
                                onChange={(event, newValue) => {
                                  setFieldValue("assigned_to", newValue || "");
                                 
                                }}
                                
                                onBlur={handleBlur}
                                getOptionLabel={(option) => option?.name || ""}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={Boolean(
                                      touched.assigned_to && errors.assigned_to
                                    )}
                                    helperText={
                                      touched.assigned_to && errors.assigned_to
                                    }
                                    label="Assign to *"
                                  />
                                )}
                              />
                            </FormControl>
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Grid container spacing={3}>
                          <Grid item xs={12} md={12}>
                            <FormControl
                              fullWidth
                              error={Boolean(
                                touched.associated_job && errors.associated_job
                              )}
                            >
                              <Autocomplete
                                id="combo-box-demo"
                                options={jobs}
                                defaultValue={values.associated_job}
                                value={values?.associated_job}
                                onChange={(event, newValue) => {
                                  setFieldValue(
                                    "associated_job",
                                    newValue || ""
                                  );
                                }}
                                onBlur={handleBlur}
                                getOptionLabel={(option) => option?.job_id}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    error={Boolean(
                                      touched.associated_job &&
                                        errors.associated_job
                                    )}
                                    helperText={
                                      touched.associated_job &&
                                      errors.associated_job
                                    }
                                    label="Assign to Job"
                                  />
                                )}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} md={12} lg={12}>
                            <TextField
                              fullWidth
                              multiline
                              rows={5}
                              name="description"
                              value={values.description}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              error={Boolean(
                                touched.description && errors.description
                              )}
                              id="search-field"
                              label="Description"
                              helperText={
                                touched.description && errors.description
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid item xs={12} md={12} lg={12}>
                        <Button
                          type="submit"
                          style={{ textAlign: "center", float: "right" }}
                          mr={2}
                          variant="contained"
                          color="primary"
                          disabled={isSubmitting}
                        >
                          Update Task
                        </Button>
                      </Grid>
                    </Grid>
                  </Paper>
                </CardContent>
              </Card>
            ) : (
              <Loading />
            )}
          </form>
        )}
      </Formik>
    </>
  );
}

const getTaskAndApUsersAndJobs = async (
  task_id,
  setTask,
  setApUsers,
  setJobs,
  setLoader
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    let url = `/api/v1/${userData?.type}/tasks/get-apusers?page=1&limit=1000`;

    const task = await axios.get(
      `/api/v1/${userData?.type}/tasks/${task_id}`,
      config
    );
    if (task.data.success) {
      let data = task.data.data;
      setTask(data);
    }

    const apUsers = await axios.get(url, config);
    if (apUsers.data.success) {
      let finalData = apUsers.data.data.data;

      if (userData.type === "super_admin") {
        let user = {
          name: "super_admin",
          _id: userData.user_id,
        };
        finalData.push(user);
      }
      let presentUserIndex = finalData.findIndex(
        (u) => u._id === userData.user_id
      );

      if (presentUserIndex >= 0) {
        finalData[presentUserIndex].name = "Super Admin";
        finalData.forEach(function (item, i) {
          if (item._id === userData.user_id) {
            finalData.splice(i, 1);
            finalData.unshift(item);
          }
        });
      }

      // let notIncludedPresentUser = apUsers.data.data.data.filter(
      //   (d) => d._id !== userData.user_id
      // );
      setApUsers(finalData);
    }
    const { data } = await axios.get(
      `/api/v1/${userData?.type}/tasks/get-jobs?limit=1000`,
      config
    );
    if (data.success) {
      setJobs(data.data.data);
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function UpdateTask() {
  const [jobs, setJobs] = useState([]);
  const [loader, setLoader] = useState(true);
  const [apUsers, setApUsers] = useState([]);
  const [task, setTask] = useState(null);
  const { task_id } = useParams();

  useEffect(() => {
    getTaskAndApUsersAndJobs(task_id, setTask, setApUsers, setJobs, setLoader);
  }, []);

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              UPDATE TASK
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/tasks">
                Tasks
              </Link>
              <Typography>Update Task</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {task && apUsers && jobs && (
              <FormDetails
                apUsers={apUsers}
                jobs={jobs}
                task={task}
                taskId={task_id}
              />
            )}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default UpdateTask;
